import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    fullName,
    signer,
    certificate,
    timeSign,

    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,

    taxpayerName,
    taxpayerId,

    capitalTransfereeName,
    capitalTransfereeTp,
    capitalTransfereeDistrict,
    capitalTransfereeTaxId,
    capitalTransfereeWards,
    capitalTransfereeAddress,

    realEstateTp,
    realEstateDistrict,
    realEstateWards,
    realEstateAddress,

    taxAgentName,
    taxAgentId,

    contractNumber,
    contractDay,
    confirmContractDay,
  },
} = checkout;

const validation = Yup.object().shape({
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
  [capitalTransfereeName.name]: Yup.string().required(capitalTransfereeName.errorMsg),
  [capitalTransfereeTp.name]: Yup.string().required(capitalTransfereeTp.errorMsg),
  [capitalTransfereeWards.name]: Yup.string().required(capitalTransfereeWards.errorMsg),
  [capitalTransfereeAddress.name]: Yup.string().required(capitalTransfereeAddress.errorMsg),
  [capitalTransfereeDistrict.name]: Yup.string().required(capitalTransfereeDistrict.errorMsg),
  [taxAgentName.name]: Yup.string().notRequired(taxAgentName.errorMsg),
  [realEstateTp.name]: Yup.string().required(realEstateTp.errorMsg),
  [realEstateDistrict.name]: Yup.string().required(realEstateDistrict.errorMsg),
  [realEstateWards.name]: Yup.string().required(realEstateWards.errorMsg),
  [realEstateAddress.name]: Yup.string().required(realEstateAddress.errorMsg),

  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [contractNumber.name]: Yup.number().required(contractNumber.errorMsg),
  [contractDay.name]: Yup.number().required(contractDay.errorMsg),
  [confirmContractDay.name]: Yup.number().notRequired(confirmContractDay.errorMsg),

  [taxpayerId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxpayerId.invalidMsg)
    .required(taxpayerId.errorMsg),
  [capitalTransfereeTaxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, capitalTransfereeTaxId.invalidMsg)
    .required(capitalTransfereeTaxId.errorMsg),
  [taxAgentId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgentId.invalidMsg)
    .notRequired(taxAgentId.errorMsg),

  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
});

export default validation;
